//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.SymbolCatalogParameterBuilderList.js";
import "../no/PDM.js";
import "../no/ObjectList.js";
let d=[[[0,"IsPartSymbol",1,0],[0,"ItemName",1,1],[0,"ItemNumber",1,1],[0,"NodeString",1,0],[1,"ParameterList",0,"Annotations.SymbolCatalogParameterBuilderList",0],[0,"PartFileName",1,0],[0,"Path",1,0],[0,"Revision",1,1],[0,"SymbolName",1,0]],[[[],"GenerateItemNumber",{},0,1],[[],"GenerateRevision",{},0,1],[[],"NewParameter",{R_:{newParameterBuilder:"Annotations.SymbolCatalogParameterBuilder"}},0,0],[["partOperationBuilder"],"SetPartOperationCreateBuilder",{},1,0],[[],"GetPartOperationCreateBuilder",{R_:{partOperationCreateBuilder:"PDM.PartOperationCreateBuilder"}},0,0]],[]];
SPLM.Annotations.SymbolCatalogBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.SymbolCatalogBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;